import { styled } from "@mui/system";
import { IBar } from "./EarningsGraph";
import { dynamicPriceFormatter } from "src/utils/helpers/PriceAndUnitsHelpers";
import { formatDollarChange } from "src/components/portfolio/helpers";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  width: "103px",
  height: "120px",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "8px",
}));

interface BarWrapperProps {
  height: string;
}
export const BarWrapper = styled("div")<BarWrapperProps>(({ height }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "6px",
  width: "100%",
}));

interface BarProps {
  background: string;
  height: string;
  maxHeight: number;
}
export const Bar = styled("div")<BarProps>(({ background, height, maxHeight }) => ({
  display: "flex",
  width: "100%",
  height: `${(Number(height) / maxHeight) * 100}%`,
  background: background,
}));

interface TextProps {
  color?: string;
  fontSize?: string;
  lineHeight?: string;
  hide?: boolean;
}
export const Text = styled("div")<TextProps>(({ color, fontSize, lineHeight, hide }) => ({
  color: color ?? "#002035",
  fontFamily: "Söhne",
  fontSize: fontSize ?? "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: lineHeight ?? "17px",
  visibility: hide ? "hidden" : "visible",
}));

interface GraphBarProps {
  bar: IBar;
}
const GraphBar = (props: GraphBarProps) => {
  const { bar } = props;
  const { background, value, month, maxValue } = bar;

  return (
    <Wrapper>
      <BarWrapper height={value}>
        <Text hide={!value}>{formatDollarChange(Number(value))}</Text>
        <Bar background={background} height={value} maxHeight={maxValue} />
      </BarWrapper>
      <Text>{month}</Text>
    </Wrapper>
  );
};

export default GraphBar;
